import { PhoneNumberUtil } from "google-libphonenumber";
import { hasAccess, accessKeys } from "./userAccess";

const PNF = PhoneNumberUtil.getInstance();

// allowInternational = true will allow phonenumbers to any country 
// allowInternational = false will only allow phonenumbers in the same country as the country the company which has the dataId is in
export function validatePhoneNumber(phoneNumber, allowInternational = false) {
  const regionCode = getRegionCode();
  let parsedNumber;
  try {
    parsedNumber = PNF.parse(phoneNumber, regionCode);
  } catch {
    return false;
  }

  return allowInternational 
    ? PNF.isValidNumber(parsedNumber) 
    : PNF.isValidNumberForRegion(parsedNumber, regionCode);
}

function getRegionCode() {
  if (hasAccess(accessKeys.swedishCompany)) {
    return "SE";
  }

  if (hasAccess(accessKeys.englishCompany)) {
    return "GB";
  }

  if (hasAccess(accessKeys.frenchCompany)) {
    return "FR";
  }

  if (hasAccess(accessKeys.norwegianCompany)) {
    return "NO";
  }

  return "SE";
}
